import { sorterDispatcher } from '@app/utils/table'

import type { Column } from '@app/components/base/Table/types'
import type { CheckingPricesCompetitorsDataSource } from '@app/pages/CheckingPricesCompetitorsPage/types'

export const getColumns = (): Array<Column<CheckingPricesCompetitorsDataSource>> => {
  return [
    {
      key: 'configName',
      dataIndex: 'configName',
      title: 'Проверки',
      width: '50%',
      sorter: (a, b) => sorterDispatcher(a.configName, b.configName)
    },
    {
      key: 'configValue',
      dataIndex: 'configValue',
      title: 'Включить/отключить',
      width: '50%'
    }
  ]
}
